import { HfsSettingsActionEnum } from 'fleet-data-model';
import { type Update } from '../../types';

export const mapObstacleAvoidanceEnabledExecutionTargets = (update: Update) => {
  return [
    {
      hfsActionId: HfsSettingsActionEnum.OBSTACLE_AVOIDANCE_ENABLED,
      iprId: update.assetId,
      payload: {
        enabled: update.enabled,
      },
    },
  ];
};
